import { api } from '@/lib/api';

export interface DbConnections {
  db: string;
  /** `null` for a schema with no registry row — the main DB, say. */
  name: string | null;
  conn: number;
}

export interface ConnectionStats {
  threadsConnected: number;
  threadsRunning: number;
  maxConnections: number;
  /** `perDb` does not account for every connected thread: the console's DB user
   *  lacks PROCESS, so MySQL showed it only its own connections. */
  partial: boolean;
  /** Connections holding no schema at all — idle pool sockets, mostly. They
   *  belong to no company, and are the difference between the headline total
   *  and what `perDb` adds up to. */
  unattributed: number;
  perDb: DbConnections[];
}

/** Server-wide MySQL connection state — every client of the server, including
 *  the accounting service, not just this console's pools. */
export function getConnectionStats() {
  return api.get<ConnectionStats>('/api/stats/connections');
}
